import { useCurrentUser } from "@knowt/syncing/hooks/user/useCurrentUser";
import { useEffect, useState } from "react";
import { SubscriptionType } from "@knowt/syncing/graphql/schema";

const PROMPT_TEN_LEFT_KEY = "PROMPT_TEN_LEFT_KEY";
const PROMPT_FIFTEEN_LEFT_KEY = "PROMPT_FIFTEEN_LEFT_KEY";

const keys = {
    10: PROMPT_TEN_LEFT_KEY,
    15: PROMPT_FIFTEEN_LEFT_KEY,
};

const storePromptProgressShowed = async (promptUsed: 10 | 15) => {
    await localStorage.setItem(keys[promptUsed], "true");
};

export const usePromptProgressLeft = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { user, subscriptionType } = useCurrentUser();

    const ai = user?.ai;
    const promptsUsed = ai?.curPrompts ?? 0;

    const limitlessPrompts = subscriptionType !== SubscriptionType.BASIC;

    useEffect(() => {
        if (!limitlessPrompts && (promptsUsed === 10 || promptsUsed === 15)) {
            // const promptAlreadyClosed = getPromptProgressShowed(promptsUsed);
            // return setIsOpen(!promptAlreadyClosed);
            //TODO: (#AIFlowOptimization) -  will be reverted in the future
            return setIsOpen(false);
        }
        return setIsOpen(false);
    }, [promptsUsed, subscriptionType, limitlessPrompts]);

    const closePopup = () => {
        setIsOpen(false);
        storePromptProgressShowed(promptsUsed as 10 | 15);
    };

    return { isOpen, closePopup, promptsUsed };
};
